import request from '../utils/request'

export default {
	async list(data) {
		const ret = await request('/v1/attendance/list', data, 'POST')
		return ret
	},
	async detailList(data) {
		const ret = await request('/v1/attendance/detailList', data, 'POST')
		return ret
	}
}